module.exports = __webpack_public_path__ + "static/img/clone_drive.36de081.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls37-1/clone_drive.png
// module id = Vr3A
// module chunks = 12